export default "__VITE_ASSET__o6OZ_ZBS__"